// Centralized pipeline status constants to avoid magic strings in UI logic

import type { RunStatus } from '@/client';

export const PipelinePhase = {
	Bnd: 'bnd',
	KbSync: 'kb_sync',
} as const;

export type PipelinePhase = (typeof PipelinePhase)[keyof typeof PipelinePhase];

/**
 * Friendly-cased mirror of the generated RunStatus union, so call sites can write
 * PipelineStatus.FailedPermanent instead of the raw 'FAILED_PERMANENT' backend string.
 */
export const PipelineStatus = {
	Pending: 'PENDING',
	InProgress: 'IN_PROGRESS',
	Completed: 'COMPLETED',
	Failed: 'FAILED',
	FailedExhausted: 'FAILED_EXHAUSTED',
	FailedPermanent: 'FAILED_PERMANENT',
	FailedStale: 'FAILED_STALE',
	Canceled: 'CANCELED',
} as const satisfies Record<string, RunStatus>;

export type PipelineStatus = (typeof PipelineStatus)[keyof typeof PipelineStatus];

// Compile-time guard: if RunStatus gains or loses a member without this file being updated to
// match, this line fails to build instead of silently drifting out of sync (see git history —
// it already had happened once, with a stale NULL/FAILED_RETRIABLE pair).
type _MissingFromPipelineStatus = Exclude<RunStatus, PipelineStatus>;
const _assertPipelineStatusCoversRunStatus: [_MissingFromPipelineStatus] extends [never] ? true : never = true;
void _assertPipelineStatusCoversRunStatus;
